export enum EnvironmentId {
  LOCAL = 'local',
  DEV = 'dev',
  STAGE = 'usgov-stage',
  USGOV = 'usgov',
  CA = 'ca',
  AU = 'au',
  CCCS = 'cccs',
  FED_STAGE = 'fed-stage',
  FEDRAMP = 'fedramp',
}

export const EnvironmentMap: { [key: string]: EnvironmentId } = {
  localhost: EnvironmentId.DEV,
  'services-dev.dev.commandcentral.com': EnvironmentId.DEV,
  'services.usgov-stage.commandcentral.com': EnvironmentId.STAGE,
  'services.usgov.commandcentral.com': EnvironmentId.USGOV,
  'services.sec.commandcentral.ca': EnvironmentId.CCCS,
  'services.commandcentral.ca': EnvironmentId.CA,
  'services.commandcentral.net.au': EnvironmentId.AU,
  'services.fed-stage.commandcentral.com': EnvironmentId.FED_STAGE,
  'services.fed.commandcentral.com': EnvironmentId.FEDRAMP,
};
